export const LIVE_BLACKJACK_TABLES = [
  {
    id: "main",
    label: "Main Blackjack",
    min: 1,
    rules: "6 decks · classic rules",
    image: "/game-art/bj-table-1.jpeg",
  },
  {
    id: "vip",
    label: "VIP Blackjack",
    min: 25,
    rules: "6 decks · high roller",
    image: "/game-art/bj-table-2.jpeg",
  },
];

export const SUIT_SYMBOL = { S: "♠", H: "♥", D: "♦", C: "♣", "?": "" };

// F02: the "+$" amount is NET winnings (profit), never the stake-inclusive return.
// `hand.payout` from the server is the stake-inclusive return; net = payout - bet.
// F01: a busted hand renders "BUST"; a non-bust loss renders "LOSS".
export function handResultLabel(hand) {
  if (!hand?.result) return null;
  const bet = Number(hand.bet || 0);
  const net = Number(hand.payout || 0) - bet;
  const amt = `$${Math.abs(net).toFixed(2)}`;
  if (hand.result === "blackjack") return `BLACKJACK +${amt}`;
  if (hand.result === "win") return `WIN +${amt}`;
  if (hand.result === "push") return "PUSH";
  if (hand.result === "surrender") return "SURRENDER";
  if (hand.status === "bust") return "BUST";
  return "LOSS";
}

export function decisionLabel(hand, active, awaitingReason) {
  if (!hand) return "";
  if (awaitingReason === "hit") return "HIT";
  if (awaitingReason === "double") return "DOUBLE";
  if (awaitingReason === "initial" || awaitingReason === "split") return "DEALING";
  if (hand.status === "bust") return "BUST";
  if (hand.status === "surrender") return "SURRENDER";
  if (hand.status === "blackjack") return "BLACKJACK";
  if (hand.status === "even_money") return "EVEN MONEY";
  if (hand.status === "stand") return "STAND";
  if (hand.status === "double") return "DOUBLE";
  if (hand.status === "playing") return active ? "DECIDING" : "WAITING";
  return "";
}


export function visibleStateDelayMs(state) {
  if (!state) return 0;
  const syncSensitive = new Set(["insurance", "acting", "dealer", "settled"]);
  if (!syncSensitive.has(state.status)) return 0;
  return Math.max(0, Math.min(30000, Number(state.stream_delay_ms || 0)));
}
